'use client';

import Error from '../../../../../_components/error';

export default Error;
